import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewBusiness from "../../../../components/@business/NewBusiness";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function BusinessNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewBusiness
                routeType={routeType}
            />
        </SettingFrame>
    )
}